var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, G } from "react-native-svg";
function SvgReduceWindow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    fill: "#fff",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M494.983 2.085h-232.51v76.126H3.633v416.488h404.039V241.732h87.311V2.085zm-112.476 461.41l-346.674-1.804v-334.75h225.761l.879 114.792h120.034v221.762zm86.341-248.54H288.587V52.952h180.261v162.003z"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    paintOrder: "fill"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M72.14 439.36l41.409-107.571 66.199 72.837L72.14 439.36z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M280.405 275.823l-129.75 117.511-28.48-33.042 129.75-117.51z"
  }))));
}
export default SvgReduceWindow;